export interface PressArticle {
  id: number;
  outlet: string;
  outletLogo: string;
  title: string;
  excerpt: string;
  url: string;
  year: string;
  type: 'interview' | 'feature' | 'review' | 'mention' | 'african-voices';
  coverImage?: string;
  coverFallback?: string;
}

export const pressArticles: PressArticle[] = [
  {
    id: 1,
    outlet: 'CNN',
    outletLogo: 'CNN',
    title: 'African Voices Changemakers Feature',
    excerpt: 'CNN spotlights the remarkable work of Oludamola Adebowale and a fellow cultural guardian in their mission to preserve Nigeria\'s rich and diverse heritage for future generations.',
    url: 'https://edition.cnn.com/2025/10/22/world/video/how-two-guardians-of-nigerian-heritage-are-preserving-culture-avcm-spc',
    year: '2025',
    type: 'african-voices',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/eee8a62a-e89c-4f4f-a071-e3516ebf6670_How-two-guardians-of-Nigerian-heritage.jpg?v=91fda1c1b297e93677cf9cae1ccf0af2',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20cultural%20heritage%20guardians%20preservation%20documentary%20warm%20portrait%20professional%20setting&width=600&height=400&seq=pfb1&orientation=landscape',
  },
  {
    id: 13,
    outlet: 'BBC Pidgin',
    outletLogo: 'BBC',
    title: 'Meet man wey dey use chess game teach Nigeria History',
    excerpt: 'BBC Pidgin features Oludamola Adebowale discussing his work as a cultural historian and archivist, and his mission to preserve Nigeria\'s rich heritage for future generations.',
    url: 'https://www.facebook.com/watch/?v=885426222624769',
    year: '2025',
    type: 'feature',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/3598e4bb-615b-4925-9398-c55d0ae33250_BBC-Pidgin-cover.png?v=0222d5f5ecc6456ca1d4aa632894df29',
    coverFallback: 'https://readdy.ai/api/search-image?query=BBC%20Pidgin%20Nigerian%20cultural%20heritage%20television%20interview%20warm%20studio%20portrait%20professional%20setting&width=600&height=400&seq=pfb13&orientation=landscape',
  },
  {
    id: 2,
    outlet: 'The Guardian Nigeria',
    outletLogo: 'Guardian',
    title: 'Renowned Nigerian Researcher Earns Honorary Doctorate for Preserving Heritage',
    excerpt: 'The Guardian Nigeria celebrates Oludamola Adebowale\'s receipt of an honorary doctorate in recognition of his decades-long commitment to preserving Nigeria\'s cultural and historical heritage.',
    url: 'https://guardian.ng/life/renowned-nigerian-researcher-earns-honorary-doctorate-for-preserving-heritage/',
    year: '2025',
    type: 'feature',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/cc96ee14-64bc-4236-9671-ba86e83bd6bf_The-Gaurdian1.jpg?v=89adf8d5e22619584cadb340c3def270',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20researcher%20honorary%20doctorate%20ceremony%20academic%20heritage%20preservation%20formal%20portrait%20warm%20lighting&width=600&height=400&seq=pfb2&orientation=landscape',
  },
  {
    id: 3,
    outlet: 'The Guardian Nigeria',
    outletLogo: 'Guardian',
    title: 'Oludamola Adebowale: Curating Memories To Outlive Generations',
    excerpt: 'An in-depth profile of Oludamola Adebowale, exploring how his curatorial vision transforms archival materials into living narratives that connect past generations to the present.',
    url: 'https://guardian.ng/life/oludamola-adebowale-curating-memories-to-outlive-generations/',
    year: '2024',
    type: 'interview',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/b00cd2c0-9532-4433-a537-6f7e0e3a01ad_The-Gaurdian2.jpg?v=d73402d90af8f1b6fe05fd5a53246088',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20curator%20archival%20memories%20cultural%20heritage%20portrait%20warm%20studio%20scholarly%20setting&width=600&height=400&seq=pfb3&orientation=landscape',
  },
  {
    id: 4,
    outlet: 'THISDAY LIVE',
    outletLogo: 'ThisDay',
    title: 'Putting Nigeria in a Global Archiving Spotlight',
    excerpt: 'Dr. Adebowale\'s pioneering archival work is placing Nigeria firmly on the global map of cultural heritage preservation, drawing international attention to the richness of West African historical records.',
    url: 'https://www.thisdaylive.com/2026/01/11/putting-nigeria-in-a-global-archiving-spotlight/',
    year: '2024',
    type: 'feature',
    coverImage: 'https://global.ariseplay.com/amg/www.thisdaylive.com/uploads/Dr.-Adebowale.jpg',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20historian%20scholar%20portrait%20professional%20man%20archival%20research%20cultural%20heritage%20documentation%20warm%20studio%20lighting%20elegant%20background&width=600&height=400&seq=pfb4&orientation=landscape',
  },
  {
    id: 5,
    outlet: 'THE NATION',
    outletLogo: 'Nation',
    title: 'When love for archive, history supercedes all',
    excerpt: 'The Nation explores how Oludamola Adebowale\'s deep passion for archival history has driven him to dedicate his life to preserving Nigeria\'s cultural memory against all odds.',
    url: 'https://thenationonlineng.net/when-love-for-archive-history-supercedes-all/',
    year: '2025',
    type: 'feature',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/99195ff5-371e-4a8f-9626-f5f820b8907b_When-love-for-archive-history-supercedes-all.png?v=6b2a8f5f64c61a96bd1dac7e9cdab598',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20archive%20history%20passion%20cultural%20preservation%20warm%20documentary%20portrait%20earthy%20tones&width=600&height=400&seq=pfb5&orientation=landscape',
  },
  {
    id: 6,
    outlet: 'NEWS AGENCY OF NIGERIA',
    outletLogo: 'NAN',
    title: 'Historian urges FG to prioritise preservation of Nigeria\'s cultural heritage',
    excerpt: 'Oludamola Adebowale calls on the Federal Government to urgently prioritise the preservation of Nigeria\'s cultural heritage, warning that irreplaceable artefacts and historical records are at risk of permanent loss.',
    url: 'https://nannews.ng/historian-urges-fg-to-prioritise-preservation-of-nigerias-cultural-heritage/',
    year: '2025',
    type: 'interview',
    coverImage: 'https://static.readdy.ai/image/aed34eea4e280644dc241a74366b8cb3/098119960247f74f1ec2e27a6bb9c4ab.png',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20cultural%20heritage%20preservation%20government%20policy%20artefacts%20historical%20records%20warm%20earthy%20tones&width=600&height=400&seq=pfb6&orientation=landscape',
  },
  {
    id: 7,
    outlet: 'DAILY TRUST',
    outletLogo: 'DailyTrust',
    title: 'Why we preserve history using illustrations',
    excerpt: 'Daily Trust speaks with Oludamola Adebowale on the power of illustration as a tool for historical preservation, and how visual storytelling brings Nigeria\'s past to life for new audiences.',
    url: 'https://dailytrust.com/why-we-preserve-history-using-illustrations/',
    year: '2024',
    type: 'interview',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/786e57c2-13dc-4b35-b60b-549363c480ae_Daisly-Trust.jpeg?v=b9d77cd2a08688661276114e79dbc11f',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20history%20illustration%20preservation%20visual%20storytelling%20warm%20artistic%20documentary%20portrait&width=600&height=400&seq=pfb7&orientation=landscape',
  },
  {
    id: 8,
    outlet: 'PEOPLE\'S GAZETTE',
    outletLogo: 'PeoplesGazette',
    title: 'Historian tasks FG on preservation of Nigeria\'s cultural heritage',
    excerpt: 'Oludamola Adebowale calls on the Federal Government to prioritise the preservation of Nigeria\'s cultural heritage, warning that irreplaceable artefacts and historical records are at risk of permanent loss.',
    url: 'https://gazettengr.com/historian-tasks-fg-on-preservation-of-nigerias-cultural-heritage/',
    year: '2025',
    type: 'interview',
    coverImage: 'https://gazettengr.com/wp-content/uploads/Nigerian-artefacts.jpg',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20cultural%20artefacts%20museum%20collection%20bronze%20sculptures%20ancient%20objects%20heritage%20preservation%20display%20warm%20gallery%20lighting%20earthy%20tones&width=600&height=400&seq=pfb8&orientation=landscape',
  },
  {
    id: 9,
    outlet: 'BELLA NAIJA',
    outletLogo: 'BellaNaija',
    title: 'ASIRI Magazine Documenting Women\'s Contributions',
    excerpt: 'ASIRI Magazine\'s groundbreaking archival project uncovers the largely untold stories of Nigerian women who shaped the nation\'s social, cultural, and political landscape in the early twentieth century.',
    url: 'https://www.bellanaija.com/2026/03/asiri-magazine-documenting-womens-contributions/',
    year: '2026',
    type: 'feature',
    coverImage: 'https://www.bellanaija.com/wp-content/uploads/2026/03/Press-Photo-2-scaled.jpg',
    coverFallback: 'https://readdy.ai/api/search-image?query=vintage%20Nigerian%20women%20historical%20photographs%201920s%201940s%20archival%20sepia%20toned%20portraits%20West%20African%20cultural%20heritage%20documentation%20warm%20cream%20background&width=600&height=400&seq=pfb9&orientation=landscape',
  },
  {
    id: 10,
    outlet: 'New Telegraph',
    outletLogo: 'NewTelegraph',
    title: 'Nigeria-Brazil: There is so much history, documentation to be done Adebowale',
    excerpt: 'New Telegraph interviews Oludamola Adebowale on the Nigeria-Brazil Public History Project and the vast untapped history connecting both nations through the transatlantic slave trade and cultural exchange.',
    url: 'https://newtelegraphng.com/nigeria-brazil-there-is-so-much-history-documentation-to-be-done-adebowale/',
    year: '2024',
    type: 'interview',
    coverImage: 'https://newtelegraphng.com/wp-content/uploads/2022/03/Oludamola-Adebowale-is-a-cultural-advocate-curator.png',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigeria%20Brazil%20cultural%20connection%20historical%20documentation%20archival%20research%20transatlantic%20heritage%20maps%20vintage%20photographs%20warm%20earthy%20tones%20scholarly&width=600&height=400&seq=pfb10&orientation=landscape',
  },
  {
    id: 11,
    outlet: 'THE NATION',
    outletLogo: 'Nation',
    title: 'LASRAB honours Adebowale',
    excerpt: 'The Lagos State Records and Archives Bureau recognises Oludamola Adebowale for his outstanding contributions to archival science and the preservation of Lagos cultural heritage.',
    url: 'https://thenationonlineng.net/lasrab-honours-adebowale/',
    year: '2025',
    type: 'mention',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/155fe82f-4a86-4b75-85b5-00c808fc5fea_LASRAB-honours-Adebowale.jpg?v=edd61b8614f9fd0fb3fb4d7005785a77',
    coverFallback: 'https://readdy.ai/api/search-image?query=Lagos%20Nigeria%20government%20ceremony%20award%20recognition%20cultural%20heritage%20archival%20institution%20formal%20event%20elegant%20hall%20warm%20lighting&width=600&height=400&seq=pfb11&orientation=landscape',
  },
  {
    id: 12,
    outlet: 'The Guardian Nigeria',
    outletLogo: 'Guardian',
    title: "Adebowale's The Man Who Didn't Die In The Face Of Tyranny pays homage to Soyinka",
    excerpt: 'A landmark curatorial tribute to Wole Soyinka, exploring the Nobel laureate\'s defiance and literary legacy through archival materials, personal correspondence, and rare photographs.',
    url: 'https://guardian.ng/features/culture/adebowales-the-man-who-didnt-die-in-the-face-of-tyranny-pays-homage-to-soyinka/',
    year: '2024',
    type: 'review',
    coverImage: 'https://cdn.guardian.ng/wp-content/uploads/2024/08/IMG-20240802-WA0009.jpg',
    coverFallback: 'https://readdy.ai/api/search-image?query=Nigerian%20literary%20exhibition%20gallery%20display%20archival%20photographs%20vintage%20documents%20Wole%20Soyinka%20tribute%20cultural%20art%20installation%20warm%20amber%20lighting&width=600&height=400&seq=pfb12&orientation=landscape',
  },
];

export const pressInquiryTypes = [
  'Interview Request',
  'Exhibition Collaboration',
  'Academic Partnership',
  'Books and Publications',
  'Media Feature',
  'Speaking Engagement',
  'General Enquiry',
];
